import React from 'react';
import { QButton } from '@qualio/ui-components';
import * as DisplayStrings from '../../../../displayStrings';

type HeaderSaveChangesButtonProps = {
  shouldShowEditViewButton: boolean;
  isDisabled: boolean;
  isLoading: boolean;
  saveForm: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
};

export const HeaderSaveChangesButton: React.FC<HeaderSaveChangesButtonProps> = ({
  shouldShowEditViewButton = false,
  isDisabled = false,
  isLoading = false,
  saveForm,
}) => {
  return shouldShowEditViewButton ? (
    <QButton data-cy={'save-and-exit'} onClick={saveForm} isDisabled={isDisabled} isLoading={isLoading}>
      {DisplayStrings.SaveChanges}
    </QButton>
  ) : null;
};
